import React from 'react';
import {
  Container, Typography, Grid, Box, Button,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/HomeViewV2/components/UI/IntroSection/IntroSection.styles';
import { ImgBox, Typography700 } from 'views/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const IntroSection = () => {
  const content = useContent('HomePage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  const interoImg = {
    large_url: content.introSectionImageDesktop?.url,
    medium_url: content.introSectionImageDesktop?.url,
    small_url: content.introSectionImageMobile?.url,
    alt: content.introSectionImageDesktop?.alt,
  };

  const introImgSrc = getSizedImage(interoImg);

  return (
    <StyledBox>
      <Box className="ISBGImg">
        <ImgBox
          image={{
            src: '/imgs/Rebranding/HomePage/IntroSectionBG.png',
            alt: 'section-BG',
          }}
          imgHeight="100%"
          imgWidth="100%"
        />
      </Box>
      <Grid
        container
        columnSpacing={{
          xl: 7,
          lg: 0,
        }}>
        <Grid item lg={7} md={12} sm={12} className="ISLefSide">
          <Box className="ISIntroImg">
            <ImgBox
              image={{ src: introImgSrc, alt: interoImg.alt }}
              data-src={introImgSrc}
              imgHeight="100%"
              imgWidth="100%"
              imgObjectFit="cover"
              unoptimized
            />
          </Box>
          <Box className="ISSubImg showTABLET">
            <ImgBox
              image={{
                src: content.introSectionSubImage?.url,
                alt: content.introSectionSubImage?.alt,
              }}
              imgHeight="100%"
              imgWidth="100%"
              imgObjectFit="cover"
              unoptimized
            />
          </Box>
        </Grid>
        <Grid item lg={5} md={12} sm={12} className="ISRightSide">
          <Container>
            <Box className="ISTextBox">
              <Typography700
                variant="h3"
                component="h3"
                className="ISTextTitle">
                {content.introSectionTitle}
              </Typography700>
              <Typography variant="bodyXL">
                {content.introSectionSubtitle}
              </Typography>
              <Button
                component={NavigatorLink}
                variant="contained"
                className="ISTextBtn"
                href={PATHS.locations()}>
                {content.introSectionCTAButtonText}
              </Button>
            </Box>
            <Box className="ISSubImg  showDESKTOP">
              <ImgBox
                image={{
                  src: content.introSectionSubImage?.url,
                  alt: content.introSectionSubImage?.alt,
                }}
                imgHeight="100%"
                imgWidth="100%"
                imgObjectFit="cover"
              />
            </Box>
          </Container>
        </Grid>
      </Grid>
    </StyledBox>
  );
};
export { IntroSection };
